module.exports = __webpack_public_path__ + "static/media/default_file.c1c928d7.png";